import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import EditarTipoIncidencia from "./EditarTipoIncidencia/EditarTipoIncidencia";
import AgregarTipoIncidencia from "./AgregarTipoIncidencia/AgregarTipoIncidencia";

moment.locale("es");

const TIPO_LABELS = {
  1: "Destajo",
  2: "Días",
  3: "Horas",
};

const SE_CONSIDERA_LABELS = {
  1: "Ninguno",
  2: "Ausencia",
  3: "Incapacidad",
  4: "Vacaciones",
};

class TiposIncidencias extends Component {
  tableRef = null;
  state = {
    todosTiposIncidencias: [],
    loading: false,
    valor: 1,
    modalAgregarTipoIncidencia: false,
    modalEditarTipoIncidencia: false,
    modalEditarTipoIncidenciaId: null,
  };

  consultarTiposIncidencias(params) {
    this.setState({ loading: true });
    axios
      .post(
        "tiposIncidencias/selectTodasTiposIncidencias",
        { empresaId: this.props.empresaId, ...params },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          this.setState({ todosTiposIncidencias: [] });
        } else {
          this.setState({
            todosTiposIncidencias: res.data.data,
            totalRecords: res.data.totalRecords || 0,
          });
        }
      });
  }

  deshabilitarTipoIncidencia(value) {
    this.setState({ loading: true });
    axios
      .post(
        "tiposIncidencias/deshabilitarTipoIncidencia",
        { tipoIncidenciaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Tipo de incidencia deshabilitado");
        } else {
          message.error("Sucedió un error y no se pudo deshabilitar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }

  habilitarTipoIncidencia(value) {
    this.setState({ loading: true });
    axios
      .post(
        "tiposIncidencias/habilitarTipoIncidencia",
        { tipoIncidenciaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Tipo de incidencia habilitado");
        } else {
          message.error("Sucedió un error y no se pudo habilitar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }

  agregarTipoIncidencia() {
    this.setState({ modalAgregarTipoIncidencia: true });
  }

  cerrarAgregarTipoIncidencia() {
    this.setState({ modalAgregarTipoIncidencia: false });
    this.tableRef.updateExternalFilters({ valor: this.state.valor });
  }

  editarTipoIncidencia(id) {
    this.setState({ modalEditarTipoIncidencia: true, modalEditarTipoIncidenciaId: id });
  }

  cerrarEditarTipoIncidencia() {
    this.setState({ modalEditarTipoIncidencia: false });
    this.tableRef.updateExternalFilters({ valor: this.state.valor });
  }

  render() {
    const columns = [
      {
        title: "Número",
        dataIndex: "numero",
        key: "numero",
        buscar: "serieNumero",
        render: (value, record) => `${record.serie} - ${record.numero}`,
        width: "6%",
      },
      {
        title: "Clave",
        dataIndex: "clave",
        key: "clave",
        buscar: "clave",
        width: "8%",
      },
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        buscar: "nombre",
        width: "16%",
      },
      {
        title: "Tipo",
        dataIndex: "tipo",
        key: "tipo",
        width: "8%",
        render: (value) => TIPO_LABELS[value] || "—",
      },
      {
        title: "Derecho a Sueldo",
        dataIndex: "derechoSueldo",
        key: "derechoSueldo",
        width: "8%",
        render: (value) =>
          value ? <Tag color="green">Sí</Tag> : <Tag color="default">No</Tag>,
      },
      {
        title: "Se Considera",
        dataIndex: "seConsidera",
        key: "seConsidera",
        width: "10%",
        render: (value) => SE_CONSIDERA_LABELS[value] || "—",
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        width: "8%",
        render: (value) => {
          if (value === 0) return <Tag color="red">Cancelado</Tag>;
          if (value === 1) return <Tag color="green">Activo</Tag>;
          if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
          return "—";
        },
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        width: "10%",
        render: (value, record) => {
          let buttons = [];

          buttons.push(
            <Tooltip
              key={`tooltip-editar-${record._id}`}
              title="Editar Tipo de Incidencia"
              placement="top"
              overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
            >
              <ButtonItem
                key={`editar-${record._id}`}
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => this.editarTipoIncidencia(record._id)}
              />
            </Tooltip>
          );

          if (record.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`deshabilitar-${record._id}`}
                title="¿Seguro que quieres deshabilitar este tipo de incidencia?"
                onConfirm={() => this.deshabilitarTipoIncidencia(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip
                  title="Deshabilitar"
                  placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                  />
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm
                key={`habilitar-${record._id}`}
                title="¿Seguro que quieres habilitar este tipo de incidencia?"
                onConfirm={() => this.habilitarTipoIncidencia(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip
                  title="Habilitar"
                  placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                >
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                  />
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Tipos de Incidencias"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[
                    { label: "Vigente", value: 1 },
                    { label: "Deshabilitado", value: 2 },
                    { label: "Todos", value: 3 },
                  ]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                    }
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              )}
              <ButtonItem
                type="primary"
                key="agregarTipoIncidencia"
                onClick={this.agregarTipoIncidencia.bind(this)}
              >
                Agregar Tipo de Incidencia
              </ButtonItem>
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          onFetchData={this.consultarTiposIncidencias.bind(this)}
          anadirValorFiltro={this.state.valor}
          size="small"
          onlyMineFilter
          dataSource={this.state.todosTiposIncidencias}
          columns={columns}
          scroll={{ x: "max-content" }}
          filterStorageKey={"tiposIncidencias" + this.props.empresaId}
          onRow={(record) => ({
            onDoubleClick: () => {
              this.editarTipoIncidencia(record._id);
            },
          })}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
        />
        <AgregarTipoIncidencia
          visible={this.state.modalAgregarTipoIncidencia}
          cerrarAgregarTipoIncidencia={this.cerrarAgregarTipoIncidencia.bind(this)}
        />
        <EditarTipoIncidencia
          visible={this.state.modalEditarTipoIncidencia}
          tipoIncidenciaId={this.state.modalEditarTipoIncidenciaId}
          cerrarEditarTipoIncidencia={this.cerrarEditarTipoIncidencia.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(TiposIncidencias);